function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.0387 5.75903H4.26248C3.7175 5.75903 3.27588 5.31741 3.27588 4.77347C3.27588 4.22849 3.7175 3.78687 4.26248 3.78687H20.0387C20.5827 3.78687 21.0243 4.22849 21.0243 4.77347C21.0243 5.31741 20.5827 5.75903 20.0387 5.75903Z",
  fill: "#F969AE"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.0387 12.6614H4.26248C3.7175 12.6614 3.27588 12.2198 3.27588 11.6758C3.27588 11.1308 3.7175 10.6892 4.26248 10.6892H20.0387C20.5827 10.6892 21.0243 11.1308 21.0243 11.6758C21.0243 12.2198 20.5827 12.6614 20.0387 12.6614Z",
  fill: "#F969AE"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.0387 19.5637H4.26248C3.7175 19.5637 3.27588 19.1221 3.27588 18.5782C3.27588 18.0332 3.7175 17.5916 4.26248 17.5916H20.0387C20.5827 17.5916 21.0243 18.0332 21.0243 18.5782C21.0243 19.1221 20.5827 19.5637 20.0387 19.5637Z",
  fill: "#F969AE"
});
function SvgIconHamburger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHamburger);
export default __webpack_public_path__ + "static/media/iconHamburger.e1c1ce67.svg";
export { ForwardRef as ReactComponent };